import Vue from 'vue'
import Vuex from 'vuex'

import restaurant from './restaurant'
import shared from './shared'
import user from './user'
import simpleMenu from './simpleMenu'

Vue.use(Vuex)

export const store = new Vuex.Store({
  modules: {
    restaurant: restaurant,
    shared: shared,
    user: user,
    simpleMenu: simpleMenu,
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js